import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { exportToExcel } from "../../helpers/exporttoexcel";
import { saleServices } from "../../services/saleServices";
import {Titlebar,Searchbox,Orderstatus} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import { Dialog, CircularProgress, } from 'primereact/dialog';
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { TabMenu } from 'primereact/tabmenu';
const OrderTracking = () =>{
    const toast = useRef(null);
    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const [filters, setFilters] = useState({'currentPage':'1','pageSize':'10','status':'All'});
    const [orderDialog, setOrderDialog] = useState(false);
    const [orderRowData, setOrderRowData] = useState([]);
    

  const [colDefs, setColDefs] = useState([
    { headerName: "SR NO", field: "id", width: 100 },
    { headerName: "Order Id", field: "order_id" },
    // { headerName: "SKU Code",field: "sku_code",cellRenderer: (params) => {
    //     return (
    //         <Tag severity="success" value={params.getValue()} rounded></Tag>

    //     );
    //   } },
    { headerName: "Sales Channel", field: "sales_channel" },
    { headerName: "Product Sold", field: "product_sold" },
    { headerName: "Date", field: "sales_date_str" },
    { headerName: "Units Sold", field: "total_units_sold" },
    { headerName: "SKU Code", field: "sku_code" },
    { headerName: "Freight Cost", field: "freight_charges" },
    { headerName: "Per Unit Sales Price", field: "sales_price" },
    { headerName: "Total Sales", field: "total_sales_price" },
    // { headerName: "Freight Charges",field: "freight_charges" },
    // { headerName: "Royalties",field: "royalties" },
    // { headerName: "Stock Reduction",field: "stock_reduction" },
    {
      headerName: "Order Status",
      field: "order_status",
      cellRenderer: (params) => {
        return <Orderstatus status={params.getValue()} />;
      },
    },

    {
      headerName: "Action",
      cellRenderer: (params) => {
        // console.log("params");
        // console.log(params.data.id);
        return (
          <>
            <button
              class="btn btn-primary btn-xs btn-white btn-border-none"
              onClick={(e) => orderTrackingDialog(params.data)}
            >
              <i class="fa-light fa-truck"></i>
            </button>
            &nbsp;
          </>
        );
      },
    },
  ]);

  useEffect(() => {
    getsalelist(filters.currentPage, filters.pageSize, filters.status);
  }, []);

  const orderTrackingDialog = async (rowdata) => {
    setOrderDialog(true);
    setLoading(true);
    await getOrderTrakingData(rowdata.id);
    setInterval(() => {
      setLoading(false);
    }, 2000)
    // setOrderRowData(rowdata);
  };

  const getsalelist = (page, pageSize, status = "All") => {
    // setUserloaded(false);
    saleServices
      .getsaledata(page, pageSize, status)
      .then((response) => {
        if (response.status == 200) {
          setResults(response.data.data.data);
          setUserloaded(false);
          setTotalRows(response.data.data.total);
          setCurrentPage(response.data.data.current_page);
        } else {
          setResults([]);
          // setUsers([]);
          setUserloaded(false);
        }
      })
      .catch((error) => {
        setResults([]);
        // setUsers([]);
        // setUserloaded(true);
      });
  };

  const getOrderTrakingData = (id) => {
    saleServices
      .getOrderTrackingData({ order_id: id })
      .then((response) => {
        if (response.status == 200) {
          setOrderRowData(response.data.data);
          console.log("THe response for order tracking , ", orderRowData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const addproductnavigate = () => {
    // navigate.
    navigate("/addsale");
  };
  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
      setFilters((prevData) => {
        return {
          ...prevData,
          currentPage: currentPage + 1,
        };
      });
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setFilters((prevData) => {
        return {
          ...prevData,
          currentPage: currentPage - 1,
        };
      });
    }
  };
  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
      setFilters((prevData) => {
        return {
          ...prevData,
          currentPage: newPage,
        };
      });
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1); // reset to page 1
    // getsalelist( 1, newSize);
    setFilters((prevData) => {
      return {
        ...prevData,
        currentPage: 1,
      };
    });
  };

  function handleStockFilter(status) {
    setFilters((prevData) => {
      return {
        ...prevData,
        currentPage: 1,
        status: status,
      };
    });
    // getsalelist(1,pageSize,status);
  }

  useEffect(() => {
    getsalelist(filters.currentPage, filters.pageSize, filters.status);
  }, [filters]);

  const handleExport = () => {
     exportToExcel({ data: orderRowData, filename: 'stock' });
  }

  return(
       <>
        <Toast ref={toast} />
          <Bredcrum divider={false}/>
          <div class="row">
              <div className='col-md-12 mb-2 mt-2'>
                 <div className='flex-box flex-between'>
                      {/* <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => addproductnavigate()}>Add New Sales</button>  */}
                      <div>
                        <Titlebar text={'Order Tracking'}/>
                      </div>
                     <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
                  </div> 
              </div> 
             
               <Dialog visible={orderDialog} position='top' modal style={{ width: '80rem' }} onHide={() => { if (!orderDialog) return; setOrderDialog(false); }}>
                           <div class="container">
                            <div>
                              <button class="export-btn form-control  pull-right" style={{width: '150px'}} onClick={() => handleExport()}>
                                <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                            </div>
                            {loading ? (
                              <div style={{ textAlign: "center", padding: "2rem" }}>
                                <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                                <p>Loading order details...</p>
                              </div>
                            ): (
                                <table className='table-bordered'>
                               <tbody>
                                 <tr>
                                   <th colSpan={11}><h3 className='text-success'>Order Info : </h3></th>
                                   
                                 </tr>
                                 <tr>
                                   <th>Sr No</th>
                                   <th>Order ID</th>
                                   <th>Sales Channel</th>
                                   <th>Product Sold</th>
                                   <th>Date</th>
                                   <th>Units Sold</th>
                                   <th>SKU Code</th>
                                   <th>Freight Cost</th>
                                   <th>Per Unit Sales Price</th>
                                   <th>Total Sales</th>
                                   <th>Order Status</th>
                                   <th>Updated at</th>
                                 </tr>
                                 {orderRowData.map((ele) => {
                                    return (

                                    <tr key={ele.id}>
                                    <td>{ele.id}</td> 
                                    <td>{ele.order_id}</td>
                                    <td>{ele.sales_channel}</td>    
                                    <td>{ele.product_name}</td>    
                                    <td>{ele.sales_date_str}</td>
                                    <td>{ele.units_sold}</td> 
                                    <td>{ele.sku_code}</td> 
                                    <td>{ele.freight_charges}</td> 
                                    <td>{ele.sales_price}</td> 
                                    <td>{ele.total_sales_price}</td> 
                                    <td>{ele.status ? ele.status : ele.order_status}</td>
                                    <td>{ele.current_status_date}</td>
                                    </tr> 
                                    )
                                 })}
                                 
                               </tbody>
                             </table>
                            )}
                           
                           </div>
                         </Dialog>
              
              {/* <Titlebar text={'Sales Overview'}/> */}
              <div className="col-md-12 mt-3">
                {/* <div className='row'>
                      <div className='col-md-9'>
                        <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
                    </div> 
                     <div className='col-md-3'>
                        <div>
                          <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                            <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                        </div>
                      </div>
                </div> */}

          <div className="card">
            <div className="card-body card-body-style">
              <Tablescom
                rowdata={results}
                coldefs={colDefs}
                isloaded={userloaded}
                quickFilterText={quickFilterText}
                paginationPageSize={filters.pageSize}
                onPaginationChanged={onPaginationChanged}
                totalRows={totalRows}
                currentPage={currentPage}
                pageSize={filters.pageSize}
                handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OrderTracking;
